import React, { useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";
import WhatsAppFab from "./WhatsAppFab";
import { Outlet, useLocation } from "react-router-dom";
import { useAnalytics } from "../../lib/analytics";

const Reveal = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    // Re-bind observer on every route change so newly mounted elements animate
    const timer = setTimeout(() => {
      const els = document.querySelectorAll(".reveal");
      if (!("IntersectionObserver" in window)) {
        els.forEach(el => el.classList.add("in"));
        return;
      }
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach(e => {
            if (e.isIntersecting) {
              e.target.classList.add("in");
              io.unobserve(e.target);
            }
          });
        },
        { threshold: 0.05, rootMargin: "0px 0px -50px 0px" }
      );
      els.forEach(el => io.observe(el));
    }, 50);
    return () => clearTimeout(timer);
  }, [pathname]);
  return null;
};

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
  return null;
};

export const Layout = () => {
  useAnalytics();
  const { pathname } = useLocation();
  const hideFab = pathname.startsWith("/admin");
  return (
    <div className="App min-h-screen bg-background text-foreground">
      <ScrollToTop />
      <Reveal />
      <Header />
      <main className="pt-20">
        <Outlet />
      </main>
      <Footer />
      {!hideFab && <WhatsAppFab />}
    </div>
  );
};

export default Layout;
